import React, { FunctionComponent } from 'react';
import { ISourceTimelineEventType } from '@24i/player-base';
import { getLiveProgressPercentageBasedOnCurrentTime } from '@24i/player-utils';
import { usePlayerTimes } from '@24i/player-utils-react';
import { Midroll } from './styled';
import { IMidrolls } from '../../../Timeline/types';

const PERCENT = 100;

const Midrolls: FunctionComponent<IMidrolls> = ({
    playerInstance,
    className = '',
    style = null,
    containerStyle = null
}) => {
    usePlayerTimes(playerInstance); // trigger re-renders on time updates

    const { programStart = 0, programEnd = 0 } = playerInstance.getMetadata();
    const { live, timeshiftRange, seekableRange, timeline, adBreaks, duration } = playerInstance;
    const windowRange = live ? timeshiftRange : seekableRange;
    const { start, end } = windowRange || {};
    const dvrWindowEndDate = playerInstance?.getUTCTimestamp(end)?.getTime() ?? Date.now();
    const advertisements =
        timeline?.filter(
            (advertisement) => advertisement.type === ISourceTimelineEventType.ADVERTISEMENT
        ) ??
        adBreaks?.map((offset) => ({ start: offset, end: offset })) ??
        [];

    const getPercentage = (adPosition) => {
        if (live && !end) {
            return null;
        }
        const unclamped = live
            ? getLiveProgressPercentageBasedOnCurrentTime(
                programStart,
                programEnd,
                start,
                end,
                adPosition,
                undefined,
                dvrWindowEndDate
            ) * PERCENT
            : (adPosition / duration) * PERCENT;
        return Math.max(0, Math.min(100, unclamped));
    };

    return (
        <div style={containerStyle}>
            {advertisements.map((advertisement) => {
                const startPercent = getPercentage(advertisement.start);
                const endPercent = getPercentage(advertisement.end);
                if (startPercent === null || endPercent === null) {
                    return null;
                }
                const length = endPercent - startPercent;
                return (
                    <Midroll
                        className={`${className} Midroll`}
                        data-test="Midroll"
                        key={`Midroll-${advertisement.start}`}
                        fromLeft={startPercent}
                        length={length}
                        style={style}
                    />
                );
            })}
        </div>
    );
};

export { Midrolls };
